import classnames from "classnames";
import PropTypes from "prop-types";

const TextArea = ({
  label,
  name,
  placeHolder,
  value,
  rows = 4,
  cols = 50,
  id,
  validationError,
  onChange,
  onBlur,
}) => {
  return (
    <div className={classnames("mb-3", { "has-error": validationError })}>
      <label className="control-label" htmlFor={name}>
        {label}
      </label>
      <textarea
        className="form-control"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        placeholder={placeHolder}
        rows={rows}
        cols={cols}
        id={id}
      />
      {validationError && <span className="help-block">{validationError}</span>}
    </div>
  );
};

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  validationError: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};

export default TextArea;
